module.exports = __webpack_public_path__ + "static/008280-98add234372fd1fe1df39444a825b657.jpg";